<template>
  <div>
    <left-menu-admin menuActive="0"></left-menu-admin>
    <v-main>
      <div class="pl-12 pr-12 col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs class="pl-0 pb-10" :items="breadcrumbs" divider=">"></v-breadcrumbs>
        <v-row>
          <v-col cols="12">
            <v-form ref="form_add" v-model="validAdd" lazy-validation>
              <div class="text-right">
                <v-btn
                  elevation="2"
                  color="success"
                  dense
                  :disabled="!validAdd"
                  @click="addData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  เพิ่ม
                </v-btn>
              </div>
              <br />
              <v-tabs v-model="tab" @change="validate()">
                <!-- <v-tabs-slider color="yellow"></v-tabs-slider> -->

                <v-tab
                  ><v-icon left>mdi-account</v-icon> ข้อมูลลูกค้า</v-tab
                >
                <v-tab
                  ><v-icon left>mdi-home-floor-b</v-icon> สาขา</v-tab
                >
                <v-tab
                  ><v-icon left>mdi-format-color-fill</v-icon> สี</v-tab
                >
                <v-tab
                  ><v-icon left>mdi-alpha-l-box</v-icon> Level</v-tab
                >
                <!-- <v-tab
                  ><v-icon left>mdi-cards</v-icon> Card</v-tab
                > -->
                <!-- <v-tab
                  ><v-icon left>mdi-gift-open</v-icon> Reward</v-tab
                > -->
                <v-tab
                  ><v-icon left>mdi-atom-variant</v-icon> Exchange Rate</v-tab
                >

                <!-- ข้อมูลลูกค้า -->
                <v-tab-item>
                  <v-card flat style="border: 1px solid black;">
                    <v-card-text>
                      <v-row justify="center">
                        <v-col cols="12" class="text-center">
                          <v-img
                            aspect-ratio="6"
                            contain
                            :src="formShop.logoPreview"
                          ></v-img>
                          <!-- <v-avatar size="100px"><img alt="Avatar" :src="formAdd.pictureUrl"></v-avatar> -->
                          <br />
                          <v-file-input
                            required
                            counter
                            show-size
                            accept="image/png, image/jpeg, image/bmp"
                            prepend-icon="mdi-camera"
                            label="โลโก้ร้าน"
                            @change="selectImgShop"
                            :rules="[rules.required]"
                            v-model="filesShop"
                          ></v-file-input>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <v-text-field
                            label="ชื่อร้าน*"
                            v-model="formShop.name"
                            :rules="[rules.required]"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <v-text-field
                            label="Channel Id (สำหรับส่งข้อความ)"
                            v-model="formShop.channelId"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            label="Client Secret (สำหรับส่งข้อความ)"
                            v-model="formShop.clientSecret"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <v-text-field
                            label="Liff Channel Id*"
                            v-model="formShop.liffChannelId"
                            :rules="[rules.required]"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            label="Liff Secret*"
                            v-model="formShop.liffSecret"
                            :rules="[rules.required]"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <v-text-field
                            label="Contact Tel*"
                            v-model="formShop.contactTel"
                            :rules="[
                              rules.required,
                              rules.counterTel,
                              rules.numberRules
                            ]"
                            :counter="10"
                            maxlength="10"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            label="userName*"
                            v-model="formUser.userName"
                            :rules="[rules.required]"
                            :counter="20"
                            maxlength="20"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <v-text-field
                            label="userPassword*"
                            v-model="formUser.userPassword"
                            :rules="[rules.required]"
                            :counter="15"
                            maxlength="15"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            v-model="formUser.userEmail"
                            :rules="[rules.required, rules.email]"
                            label="E-mail"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <v-autocomplete
                            clearable
                            v-model="formUser.userTypeGroup"
                            :items="UserTypeGroup"
                            :rules="[rules.required]"
                            attach
                            chips
                            label="กลุ่มผู้ใช้งาน"
                            dense
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            label="Display Name*"
                            v-model="formUser.displayName"
                            :rules="[rules.required]"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <v-menu
                            v-model="menu99"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="formUser.EXPIRY_DATE"
                                prepend-icon="mdi-calendar"
                                label="วันที่ หมดอายุ"
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="formUser.EXPIRY_DATE"
                              @input="menu99 = false"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                dense
                                dark
                                color="red"
                                @click="
                                  (formUser.EXPIRY_DATE = ''), (menu99 = false)
                                "
                              >
                                Clear
                              </v-btn>
                              <v-btn
                                dense
                                color="primary"
                                @click="
                                  (formUser.EXPIRY_DATE = new Date()
                                    .toISOString()
                                    .substr(0, 10)),
                                    (menu99 = false)
                                "
                              >
                                วันที่ปัจจุบัน
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <!-- สาขา -->
                <v-tab-item>
                  <v-card flat style="border: 1px solid black;">
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field
                              v-model="formBranch.masBranchName"
                              label="ชื่อ สาขา"
                              placeholder="ชื่อ สาขา"
                              outlined
                              dense
                              required
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <!-- สี -->
                <v-tab-item>
                  <v-card flat style="border: 1px solid black;">
                    <v-card-text>
                      <v-spacer></v-spacer>
                      <v-checkbox
                        v-model="canvas"
                        label="เปิด / ปิด Canvas"
                      ></v-checkbox>
                      <v-container>
                        <v-row style="height: 50px">
                          <v-col cols="6">
                            <v-alert
                              :color="formColor.color1"
                              dense
                              icon="mdi-alpha-h-box"
                              type="success"
                              border="bottom"
                              >Headline</v-alert
                            >
                          </v-col>
                          <v-col cols="6">
                            <v-alert
                              :color="formColor.color2"
                              dense
                              icon="mdi-alpha-i-box"
                              type="success"
                              border="bottom"
                              >Icon</v-alert
                            >
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6" class="d-flex justify-center">
                            <v-color-picker
                              :hide-canvas="!canvas"
                              mode="hexa"
                              hide-mode-switch
                              v-model="formColor.color1"
                            ></v-color-picker>
                          </v-col>
                          <v-col cols="6" class="d-flex justify-center">
                            <v-color-picker
                              :hide-canvas="!canvas"
                              mode="hexa"
                              hide-mode-switch
                              v-model="formColor.color2"
                            ></v-color-picker>
                          </v-col>
                        </v-row>
                        <v-row style="height: 50px">
                          <v-col cols="6">
                            <v-alert
                              :color="formColor.color3"
                              dense
                              icon="mdi-alpha-s-box"
                              type="success"
                              border="bottom"
                              >Sub-headline</v-alert
                            >
                          </v-col>
                          <v-col cols="6">
                            <v-alert
                              :color="formColor.color4"
                              dense
                              icon="mdi-format-header-2"
                              type="success"
                              border="bottom"
                              >Headline 2</v-alert
                            >
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6" class="d-flex justify-center">
                            <v-color-picker
                              :hide-canvas="!canvas"
                              mode="hexa"
                              hide-mode-switch
                              v-model="formColor.color3"
                            ></v-color-picker>
                          </v-col>
                          <v-col cols="6" class="d-flex justify-center">
                            <v-color-picker
                              :hide-canvas="!canvas"
                              mode="hexa"
                              hide-mode-switch
                              v-model="formColor.color4"
                            ></v-color-picker>
                          </v-col>
                        </v-row>
                        <v-row style="height: 50px">
                          <v-col cols="6">
                            <v-alert
                              :color="formColor.color5"
                              dense
                              icon="mdi-alpha-s-box-outline"
                              type="success"
                              border="bottom"
                              >Sub-headline 2</v-alert
                            >
                          </v-col>
                          <v-col cols="6">
                            <v-alert
                              :color="formColor.color6"
                              dense
                              icon="mdi-alpha-i-box-outline"
                              type="success"
                              border="bottom"
                              >lcon 2</v-alert
                            >
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6" class="d-flex justify-center">
                            <v-color-picker
                              :hide-canvas="!canvas"
                              mode="hexa"
                              hide-mode-switch
                              v-model="formColor.color5"
                            ></v-color-picker>
                          </v-col>
                          <v-col cols="6" class="d-flex justify-center">
                            <v-color-picker
                              :hide-canvas="!canvas"
                              mode="hexa"
                              hide-mode-switch
                              v-model="formColor.color6"
                            ></v-color-picker>
                          </v-col>
                        </v-row>
                        <v-row style="height: 50px">
                          <v-col cols="6">
                            <v-alert
                              :color="formColor.color7"
                              dense
                              icon="mdi-alpha-p-box"
                              type="success"
                              border="bottom"
                              >Picture</v-alert
                            >
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6" class="d-flex justify-center">
                            <v-color-picker
                              :hide-canvas="!canvas"
                              mode="hexa"
                              hide-mode-switch
                              v-model="formColor.color7"
                            ></v-color-picker>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <!-- Level -->
                <v-tab-item>
                  <v-card flat style="border: 1px solid black;">
                    <v-card-text>
                      <v-container>
                        <v-row justify="center">
                          <v-col cols="12" class="text-center">
                            <v-img
                              aspect-ratio="6"
                              contain
                              :src="formLevel.pictureUrlPreview"
                            ></v-img>
                            <!-- <v-avatar size="100px"><img alt="Avatar" :src="formAdd.pictureUrl"></v-avatar> -->
                            <br>
                            <v-file-input
                              required
                              counter
                              show-size
                              :rules="[rules.required]"
                              accept="image/png, image/jpeg, image/bmp"
                              prepend-icon="mdi-camera"
                              label="Image"
                              @change="selectImgLevel"
                              v-model="filesLevel"
                            ></v-file-input>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6">
                            <v-text-field
                              v-model="formLevel.name"
                              label="ชื่อ Level"
                              placeholder="ชื่อ Level"
                              outlined
                              dense
                              required
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <VuetifyMoney
                              v-model="formLevel.point"
                              label="Point"
                              outlined
                              dense
                              required
                              v-bind:options="options2"
                              :rules="[rules.required]"
                            />
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-textarea
                              auto-grow
                              outlined
                              rows="2"
                              name="input-7-4"
                              label="Priviledge"
                              placeholder="Priviledge"
                              counter
                              dense
                              required
                              :rules="[
                                rules.required
                              ]"
                              v-model="formLevel.priviledge"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <!-- Card -->
                <!-- <v-tab-item>
                  <v-card flat style="border: 1px solid black;">
                    <v-card-text>
                      <v-container>
                        <v-row justify="center">
                          <v-col cols="12" class="text-center">
                            <v-img
                              aspect-ratio="6"
                              contain
                              :src="formCard.pictureUrlPreview"
                            ></v-img>
                            <br />
                            <v-file-input
                              required
                              counter
                              show-size
                              accept="image/png, image/jpeg, image/bmp"
                              prepend-icon="mdi-camera"
                              label="Image"
                              @change="selectImgCard"
                              v-model="filesCard"
                              :rules="[rules.required]"
                            ></v-file-input>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6">
                            <v-text-field
                              v-model="formCard.name"
                              label="ชื่อ Card"
                              placeholder="ชื่อ Card"
                              outlined
                              dense
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-tab-item> -->
                <!-- Reward -->
                <!-- <v-tab-item>
                  <v-card flat style="border: 1px solid black;">
                    <v-card-text>
                      <v-container>
                        <v-row justify="center">
                          <v-col cols="12" class="text-center">
                            <v-img
                              aspect-ratio="6"
                              contain
                              :src="formReward.pictureUrlPreview"
                            ></v-img>
                            <br />
                            <v-file-input
                              required
                              counter
                              show-size
                              accept="image/png, image/jpeg, image/bmp"
                              prepend-icon="mdi-camera"
                              label="Image"
                              @change="selectImgReward"
                              v-model="filesReward"
                              :rules="[rules.required]"
                            ></v-file-input>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6">
                            <v-text-field
                              v-model="formReward.name"
                              label="ชื่อ Reward"
                              placeholder="ชื่อ Reward"
                              outlined
                              dense
                              required
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              v-model="formReward.subName"
                              label="ชื่อรอง Reward"
                              placeholder="ชื่อรอง Reward"
                              outlined
                              dense
                              required
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6">
                            <VuetifyMoney
                              v-model="formReward.point"
                              label="Point"
                              outlined
                              dense
                              required
                              :rules="[rules.required]"
                              v-bind:options="options2"
                            />
                          </v-col>
                          <v-col cols="6">
                            <VuetifyMoney
                              v-model="formReward.quota"
                              label="Quota"
                              outlined
                              dense
                              required
                              :rules="[rules.required]"
                              v-bind:options="options2"
                            />
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-textarea
                              auto-grow
                              outlined
                              rows="2"
                              name="input-7-4"
                              label="รายละเอียด"
                              placeholder="รายละเอียด"
                              counter
                              dense
                              required
                              v-model="formReward.description"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6">
                            <v-menu
                              v-model="menu3"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="formReward.startDate"
                                  prepend-icon="mdi-calendar"
                                  label="วันที่เริ่มใช้งาน"
                                  v-bind="attrs"
                                  v-on="on"
                                  :rules="[rules.required]"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="formReward.startDate"
                                @input="menu3 = false"
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  dense
                                  color="red"
                                  dark
                                  @click="
                                    (formReward.startDate = ''), (menu3 = false)
                                  "
                                >
                                  Clear
                                </v-btn>
                                <v-btn
                                  dense
                                  color="primary"
                                  @click="
                                    (formReward.startDate = new Date()
                                      .toISOString()
                                      .substr(0, 10)),
                                      (menu3 = false)
                                  "
                                >
                                  วันที่ปัจจุบัน
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="6">
                            <v-menu
                              v-model="menu4"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="formReward.endDate"
                                  prepend-icon="mdi-calendar"
                                  label="วันหมดอายุ"
                                  v-bind="attrs"
                                  v-on="on"
                                  :rules="[rules.required]"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="formReward.endDate"
                                @input="menu4 = false"
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  dense
                                  color="red"
                                  dark
                                  @click="
                                    (formReward.endDate = ''), (menu4 = false)
                                  "
                                >
                                  Clear
                                </v-btn>
                                <v-btn
                                  dense
                                  color="primary"
                                  @click="
                                    (formReward.endDate = new Date()
                                      .toISOString()
                                      .substr(0, 10)),
                                      (menu4 = false)
                                  "
                                >
                                  วันที่ปัจจุบัน
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4">
                            <v-checkbox
                              v-model="formReward.trending"
                              label="Trending this week"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="4">
                            <v-checkbox
                              v-model="formReward.most"
                              label="Most popular"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="4">
                            <v-checkbox
                              v-model="formReward.specialOffer"
                              label="Special offer"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-tab-item> -->
                <!-- Exchange Rate -->
                <v-tab-item>
                  <v-card flat style="border: 1px solid black;">
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="6">
                            <v-text-field
                              v-model="formExchangeRate.name"
                              label="ชื่อ Exchange Rate"
                              placeholder="Product Exchange Rate"
                              outlined
                              dense
                              required
                              :rules="[
                                rules.required
                              ]"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <VuetifyMoney
                              v-model="formExchangeRate.exchangeRate"
                              label="ExchangeRate"
                              outlined
                              dense
                              required
                              :rules="[rules.required]"
                              v-bind:options="options2"
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs>
              <br>
              <div class="text-right">
                <v-btn
                  elevation="2"
                  color="success"
                  dense
                  :disabled="!validAdd"
                  @click="addData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  เพิ่ม
                </v-btn>
              </div>
            </v-form>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import VuetifyMoney from '../VuetifyMoney.vue'
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    VuetifyMoney
  },
  created () {
    // setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      session: this.$session.getAll(),
      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        resizeImag: value =>
          !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      // End Form Config ADD EDIT
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'เพิ่ม Shop',
          disabled: true,
          href: '/System/Shop'
        }
      ],
      options2: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 9,
        precision: 0
      },
      tab: 0,
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu99: false,
      canvas: true,
      validAdd: true,
      UserTypeGroup: [],
      code: 'SYS_USER_', // Generate Code
      codeBranch: 'BCH_', // Generate Code
      formShop: {
        shopId: '',
        name: '',
        logo: '',
        logoPreview: '',
        channelId: '',
        liffChannelId: '',
        liffSecret: '',
        liffId: '',
        contactTel: '',
        clientSecret: '',
        expireDate: '',
        CREATE_USER: '',
        LAST_USER: ''
      },
      formUser: {
        userCode: '',
        userName: '',
        userPassword: '',
        userEmail: '',
        // userType: 'U',
        userTypeGroup: '',
        // empCode: '',
        EXPIRY_DATE: '',
        shopId: '',
        CREATE_USER: '',
        LAST_USER: ''
      },
      formBranch: {
        masBranchCode: '',
        masBranchName: '',
        shopId: '',
        CREATE_USER: '',
        LAST_USER: ''
      },
      formColor: {
        color1: '#871B12FF',
        color2: '#CA3433FF',
        color3: '#FF6059FF',
        color4: '#323232FF',
        color5: '#696969FF',
        color6: '#808588FF',
        color7: '#D9DDDCFF',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: ''
      },
      formLevel: {
        name: 'start',
        point: 0,
        priviledge: 'สิทธิพิเศษ',
        pictureUrlPreview: '',
        pictureUrl: '',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: ''
      },
      formCard: {
        name: 'card',
        pictureUrlPreview: '',
        pictureUrl: '',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: ''
      },
      formReward: {
        name: '',
        subName: '',
        point: 0,
        quota: 0,
        description: '',
        startDate: new Date().toISOString().substr(0, 10),
        endDate: new Date().toISOString().substr(0, 10),
        CREATE_USER: '',
        LAST_USER: '',
        pictureUrl: '',
        pictureUrlPreview: '',
        trending: false,
        most: false,
        specialOffer: false,
        shopId: ''
      },
      formExchangeRate: {
        name: 'ค่าเริ่มต้น',
        exchangeRate: 100,
        CREATE_USER: '',
        LAST_USER: '',
        shopId: ''
      },
      filesLevel: null,
      filesCard: null,
      filesReward: null,
      filesShop: null
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // this.getGetToken(this.DNS_IP)
    this.dataReady = false
    // Get Data
    // await this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId)
    await this.getDataTypeGroup()
    await this.validate()
  },
  methods: {
    validate () {
      console.log(this.tab)
      this.$nextTick(() => {
        let self = this
        self.$refs.form_add.validate()
      })
    },
    selectImgShop () {
      if (this.filesShop) {
        this.formShop.logoPreview = URL.createObjectURL(this.filesShop)
      } else {
        this.formShop.logoPreview = ''
      }
    },
    selectImgCard () {
      if (this.filesCard) {
        this.formCard.pictureUrlPreview = URL.createObjectURL(this.filesCard)
      } else {
        this.formCard.pictureUrlPreview = ''
      }
    },
    selectImgLevel () {
      if (this.filesLevel) {
        this.formLevel.pictureUrlPreview = URL.createObjectURL(this.filesLevel)
      } else {
        this.formLevel.pictureUrlPreview = ''
      }
    },
    selectImgReward () {
      if (this.filesReward) {
        this.formReward.pictureUrlPreview = URL.createObjectURL(this.filesReward)
      } else {
        this.formReward.pictureUrlPreview = ''
      }
    },
    async getDataTypeGroup () {
      // Clear Data ทุกครั้ง
      this.UserTypeGroup = []
      // console.log('getDataTypeGroup')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/system_user_type_group/" + "get"
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.userTypeGroupName
            s.text = d.userTypeGroupName
            d = s
            console.log(d)
            this.UserTypeGroup.push(d)
          }
          // console.log('getDataTypeGroup : ', this.UserTypeGroup)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
        })
    },
    async addData () {
      const today = new Date()
      // console.log(today)
      const date =
        today.getFullYear() +
        '' +
        (today.getMonth() + 1) +
        '' +
        today.getDate()
      const time =
        today.getHours() + '' + today.getMinutes() + '' + today.getSeconds()
      const shopId = date + '' + time
      this.formShop.shopId = shopId
      this.formBranch.shopId = shopId
      this.formUser.shopId = shopId
      this.formColor.shopId = shopId
      this.formLevel.shopId = shopId
      this.formCard.shopId = shopId
      this.formReward.shopId = shopId
      this.formExchangeRate.shopId = shopId
      // this.formShop.shopId = parseInt(shopId)
      // this.formUser.shopId = parseInt(shopId)
      // this.formColor.shopId = parseInt(shopId)
      // this.formLevel.shopId = parseInt(shopId)
      // this.formCard.shopId = parseInt(shopId)
      // this.formReward.shopId = parseInt(shopId)
      await this.addDataUser()
      await this.addDataSHop()
      await this.addDataBranch()
      await this.addDataColor()
      await this.addDataLevel()
      // await this.addDataCard()
      // await this.addDataReward()
      await this.addDataExchangeRate()
      this.$router.push('/system/Shop')
    },
    async addDataUser () {
      console.log(this.formUser)
      this.formUser.userCode = this.code + this.generateCodeGlobal()
      this.formUser.CREATE_USER = this.session.data.userName
      this.formUser.LAST_USER = this.session.data.userName
      if (this.formUser.EXPIRY_DATE === '') {
        delete this.formUser['EXPIRY_DATE']
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/system_user/add",
          this.formUser
        )
        .then(async response => {
          // Debug response
          console.log('addDataGlobal DNS_IP + PATH + "add"', response)

          // this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
          // Close Dialog

          // Load Data
          // await this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId)
          // await this.reloadData()
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log('error function addDataGlobal : ', error)
        })
    },
    async addDataBranch () {
      console.log(this.formBranch)
      this.formBranch.masBranchCode = this.codeBranch + this.generateCodeGlobal()
      this.formBranch.CREATE_USER = this.session.data.userName
      this.formBranch.LAST_USER = this.session.data.userName
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_branch/add",
          this.formBranch
        )
        .then(async response => {
          // Debug response
          console.log('addDataGlobal DNS_IP + PATH + "add"', response)

          // this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
          // Close Dialog

          // Load Data
          // await this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId)
          // await this.reloadData()
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log('error function addDataGlobal : ', error)
        })
    },
    async addDataSHop () {
      console.log(this.formShop)
      if (this.formUser.EXPIRY_DATE === '') {
        delete this.formShop['expireDate']
      } else {
        this.formShop.expireDate = this.formUser.EXPIRY_DATE
      }
      this.formShop.CREATE_USER = this.session.data.userName
      this.formShop.LAST_USER = this.session.data.userName
      const _this = this
      let params = new FormData()
      params.append('file', this.filesShop)

      await axios.post(this.DNS_IP + `/file/upload/reward`, params).then(function (response) {
        _this.formShop.logo = _this.DNS_IP + '/' + response.data
        console.log('url Pic', response.data)
      })
      delete this.formShop['logoPreview']
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/system_shop/add",
          this.formShop
        )
        .then(async response => {
          // Debug response
          console.log('addDataGlobal DNS_IP + PATH + "add"', response)

          // this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
          // Close Dialog

          // Load Data
          // await this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId)
          // await this.reloadData()
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log('error function addDataGlobal : ', error)
        })
    },
    async addDataColor () {
      console.log(this.formColor)
      this.formColor.CREATE_USER = this.session.data.userName
      this.formColor.LAST_USER = this.session.data.userName
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/color/add",
          this.formColor
          //   {
          //     headers: {
          //       'Application-Key': this.$session.getAll().ApplicationKey
          //     }
          //   }
        )
        .then(async (response) => {
          // Debug response
          console.log('addDataGlobal DNS_IP + PATH + "add"', response)

          // this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
          // Close Dialog

          // Load Data
          // await this.clearData()
          // await this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId)
        })
      // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function addDataGlobal : ', error)
        })
    },
    async addDataLevel () {
      console.log(this.formLevel)
      this.formLevel.CREATE_USER = this.session.data.userName
      this.formLevel.LAST_USER = this.session.data.userName
      const _this = this
      let params = new FormData()
      params.append('file', this.filesLevel)

      await axios.post(this.DNS_IP + `/file/upload/reward`, params).then(function (response) {
        _this.formLevel.pictureUrl = _this.DNS_IP + '/' + response.data
        console.log('url Pic', response.data)
      })
      delete this.formLevel['pictureUrlPreview']
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/level/add",
          this.formLevel
          //   {
          //     headers: {
          //       'Application-Key': this.$session.getAll().ApplicationKey
          //     }
          //   }
        )
        .then(async (response) => {
          // Debug response
          console.log('addDataGlobal DNS_IP + PATH + "add"', response)

          // this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
          // Close Dialog

          // Load Data
          // await this.clearData()
          // await this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId)
        })
      // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function addDataGlobal : ', error)
        })
    },
    async addDataCard () {
      console.log(this.formCard)
      this.formCard.CREATE_USER = this.session.data.userName
      this.formCard.LAST_USER = this.session.data.userName
      const _this = this
      let params = new FormData()
      params.append('file', this.filesCard)

      await axios.post(this.DNS_IP + `/file/upload/reward`, params).then(function (response) {
        _this.formCard.pictureUrl = _this.DNS_IP + '/' + response.data
        console.log('url Pic', response.data)
      })
      delete this.formCard['pictureUrlPreview']
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/card/add",
          this.formCard
        )
        .then(async response => {
          // Debug response
          console.log('addDataGlobal DNS_IP + PATH + "add"', response)

          // this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
          // Close Dialog

          // Load Data
          // await this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId)
          // await this.reloadData()
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log('error function addDataGlobal : ', error)
        })
    },
    async addDataReward () {
      console.log(this.formReward)
      this.formReward.CREATE_USER = this.session.data.userName
      this.formReward.LAST_USER = this.session.data.userName
      const _this = this
      let params = new FormData()
      params.append('file', this.filesReward)

      await axios.post(this.DNS_IP + `/file/upload/reward`, params).then(function (response) {
        _this.formReward.pictureUrl = _this.DNS_IP + '/' + response.data
        console.log('url Pic', response.data)
      })
      delete this.formReward['pictureUrlPreview']
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/reward/add",
          this.formReward
          //   {
          //     headers: {
          //       'Application-Key': this.$session.getAll().ApplicationKey
          //     }
          //   }
        )
        .then(async (response) => {
          // Debug response
          console.log('addDataGlobal DNS_IP + PATH + "add"', response)

          this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
          // Close Dialog

          // Load Data
          // await this.clearData()
          // this.filesAdd = null
          // await this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId)
        })
      // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function addDataGlobal : ', error)
        })
    },
    async addDataExchangeRate () {
      console.log(this.formExchangeRate)
      this.formExchangeRate.CREATE_USER = this.session.data.userName
      this.formExchangeRate.LAST_USER = this.session.data.userName
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/productExchangeRate/add",
          this.formExchangeRate
          //   {
          //     headers: {
          //       'Application-Key': this.$session.getAll().ApplicationKey
          //     }
          //   }
        )
        .then(async (response) => {
          // Debug response
          console.log('addDataGlobal DNS_IP + PATH + "add"', response)

          this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
          // Close Dialog

          // Load Data
          // await this.clearData()
          // await this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId)
        })
      // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function addDataGlobal : ', error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/System/Shop.vue